<template lang="html">
  <b-row class="mb-4">
    <b-col>
      <h1>Search</h1>
      <b-row>
        <b-col md="6">
          <b-form-input
            id="input-large"
            v-model="searchText"
            size="lg"
            placeholder="Enter a song title or artist's name"
            @keydown.enter.native="search"
          />
        </b-col>
        <b-col class="pl-0">
          <b-btn size="lg" @click="search">Search</b-btn>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "SearchField",
  data() {
    return {
      searchText: ""
    };
  },
  mounted() {
    this.searchText = this.$route.query.search || "";
  },
  methods: {
    search() {
      this.$router.push({
        name: "all",
        query: {
          search: this.searchText
        }
      });
    }
  }
};
</script>

<style lang="css" scoped></style>
